// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";

type $Props = {
  classes: Object,
};

type $SubHeadingProps = {
  children: any,
};

const SubHeading = ({ children }: $SubHeadingProps) => (
  <strong>
    <u>{children}</u>
  </strong>
);

const Elevate = ({ classes }: $Props) => (
  <div className={classes.root}>
    <Typography type="heading2" gutterTop gutterBottom>
      User Agreements: Terms of Service
    </Typography>
    <Hr />
    <Typography type="body" gutterTop gutterBottom>
      <strong>1. GENERAL.</strong>
      <br /> This website is operated by Elm Street Technology, LLC or its
      affiliates (collectively and individually referred to as “Provider” “we”
      “us&quot; or “our”). This website and products, features, content and
      services offered by or on behalf of Provider through the website, and
      connected mobile application and/or platform, as applicable, are directed
      to our customers (collectively, the “Services”). Individual Services may
      be subject to additional terms specific to that Service and the specific
      Services ordered will be confirmed in Provider’s order form (the
      “Additional Terms”). All such Additional Terms are incorporated by
      reference into these Terms of Service Use (collectively forming this
      “Agreement”). Our Privacy Policy posted online where you access our
      Services online, as it may be updated from time to time, is a key
      Additional Term, and you consent to our processing your personal
      information per the Privacy Policy.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Please familiarize yourself with the terms of this Agreement. By accessing
      or using the Services, or signing a copy of this Agreement, you agree to
      be bound by the terms of this Agreement, which govern your use (and if
      applicable, if you are contracting on behalf of a business, that
      business’s use) of the Services. If you do not agree with any part of this
      Agreement, please notify us and suspend use of the Services right away.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Our Services are not for minors. By accessing the Services and/or creating
      an account with us or subscribing for specific Services, you represent and
      warrant to us you are at least 18 years of age (or older if 18 is not the
      age of majority where you reside). If you are using Services on behalf of
      a business, you represent and warrant to us, as a condition to accessing
      the Services, that you have full and complete authority to bind the
      business to comply with all of the terms of this Agreement.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>2. CHANGES.</strong> <br />
      We may modify, suspend or terminate Services, in whole or in part, change
      the terms of this Agreement from time to time, at any time, without prior
      notice. Any modifications to this Agreement shall be effective upon
      posting the updated version by us to our website(s), notifying you through
      the Services, or otherwise communicating the change to you. Your continued
      use of Services following any such changes signifies your consent to
      remain bound by the terms of this Agreement, as modified.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>3. PRIVACY.</strong> <br />
      Use of personal information you provide to us, or we collect from you in
      order to make the Services available, is subject to the terms of our
      Privacy Policy. The terms of the Privacy Policy, as it may be updated from
      time to time, are incorporated into and made part of this Agreement by
      reference.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>4. ACCOUNT REGISTRATION.</strong> <br /> We may offer different
      types of accounts depending on how you use the Services or which specific
      Services you subscribe for (for example, based on your role as a real
      estate agent/broker, team member of such individual, or service provider
      or customer thereof, and reserve the right to limit which kind of account
      you qualify for based on how you would use and access the Services).
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>5. PROTECT YOUR ACCOUNT.</strong> <br /> YOU ARE RESPONSIBLE FOR
      ALL ACTIVITY THROUGH YOUR ACCOUNT OR USING YOUR LOG- IN CREDENTIALS TO THE
      SERVICES, WHETHER OR NOT AUTHORIZED BY YOU. Secure your password and user
      name from unauthorized access. Notify us right away if you suspect any
      unauthorized access. You are legally responsible for all transactions
      initiated through your account. If you suspect that someone may have
      obtained access to your password, who is not intended to have authority to
      act on your behalf, please contact us. You understand and agree that we
      may require you to change your account password periodically for security
      purposes or require additional security measures for you to access your
      account.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>6. USE OF SERVICES.</strong> <br />
      A. <SubHeading>Lawful Purposes</SubHeading>. You represent, warrant and
      covenant that you will not use the Services for any purpose that is
      unlawful under applicable laws that apply to you (including without
      limitation, advertising, marketing, privacy and consumer protection laws),
      or prohibited by this Agreement. You are also responsible to comply with
      all applicable license or industry standards that apply to you in your
      jurisdiction.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      B. <SubHeading>Limited Access Rights</SubHeading>. We hereby grant you the
      limited right to access and use the Services only for the purposes of
      accessing, viewing, downloading, posting, and printing information from
      and to the Services for your personal and non-commercial use. You shall
      not modify, copy, distribute, transmit, display, perform, reproduce,
      publish, license, broadcast, create derivative works from, transfer, or
      sell any information, software, products or services obtained from us via
      the Services, including, without limitation, any Multiple Listing Service
      (“MLS”) data, text, artwork, graphics, logos, button icons, images, audio
      clips, digital downloads, product and service descriptions,
      advertisements, directory information, and data compilations
      (collectively, “Content”). We reserve the right to suspend or deny, in our
      sole discretion, your access to all or any portion of the Services as
      described in Section 15 below. Any rights not expressly granted to you
      herein are reserved to us and our licensors.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      C. <SubHeading>No Reliance</SubHeading>. The Services may include
      information, tips, facts, views, and opinions. ALL SUCH INFORMATION IS FOR
      INFORMATIONAL PURPOSES ONLY AND SHOULD NOT BE CONSIDERED AS PROFESSIONAL,
      LEGAL, TAX OR ACCOUNTING ADVICE. SUCH INFORMATION SHOULD NOT BE RELIED
      UPON FOR PERSONAL, MEDICAL, LEGAL, BUSINESS, FINANCIAL, OR OTHER DECISIONS
      WITHOUT INDEPENDENT VERIFICATION AND ANALYSIS. WE ARE NOT IN THE BUSINESS
      OF PROVIDING ANY SUCH ADVICE. WE DISCLAIM ANY AND ALL WARRANTIES RELATING
      TO SUCH INFORMATION, TIPS, FACTS, VIEWS OR OPINIONS. YOU RELY ON THEM AT
      YOUR OWN RISK.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      D. <SubHeading>Accuracy of Your Content</SubHeading>. If you are a real
      estate agent or broker, in keeping with the trust characteristics of your
      profession, we depend on you to accurately identify and represent yourself
      when using the Services and use best efforts not to input inaccurate,
      false, incomplete or misleading information to the Services. You agree to
      update and correct any errors as soon as you become aware of them.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      E. <SubHeading>Hold Harmless</SubHeading>. You will defend, indemnify and
      hold us and our members, managers, subsidiaries, affiliates, officers,
      employees, agents, and other partners harmless against any and all claims,
      damages, judgments, and expenses, including attorney’s fees, and
      litigation costs and expenses arising from your use of the Services other
      than as required or permitted under this Agreement.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      F. <SubHeading>Services Data</SubHeading>. We reserve the right to collect
      usage statistics across users of our Services, regarding how the Services
      are used, to maintain, secure, improve and troubleshoot our offerings and
      for any other of our business purposes.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>7. OUR COMMUNICATIONS WITH YOU</strong> <br />
      (TCPA Consent for United States Residents) <br />
      A. <SubHeading>Your Express Consent to Us</SubHeading>. By using the
      Services and submitting your contact information, you are providing your
      express written consent to receive Communications from Provider, from or
      through our Services or from users of our Services at the email address
      and telephone numbers you entered into your account registration or
      contact form, or that you later provide to us via your account or the
      Services. Such “Communications” may take the form of via live calls,
      automated or prerecorded emails, texts, or calls.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      B. <SubHeading>Emails, Texts and Calls</SubHeading>. Communications may
      include Services updates, information about other products and services,
      and telemarketing messages, through the use of email, landline phone,
      cellular phone, and text messages (including sms and mms).
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      C. <SubHeading>Automation</SubHeading>. We, the Services or Real Estate
      Professional Users may contact you via live, automated or prerecorded
      email, text, or call. Your carrier’s standard rates and charges may apply.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      D. <SubHeading>Revoking Consent and Opting Out</SubHeading>. Consent to
      receive texts is not a condition to access or purchase Services and you
      may revoke this consent by contacting us at [support@elmstreet.com] or
      responding STOP to texts. Texting STOP back to us is the quickest way to
      stop text Communications. You consent to receive a final text message
      confirming your opt-out. You may unsubscribe from marketing or commercial
      emails within the email itself. Please allow up to 10 days for the email
      unsubscribe to take effect. Unsubscribing from marketing emails does not
      limit our ability to communicate with you by email regarding our present
      or past business relationship with you, as a user of Services.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      E.{" "}
      <SubHeading>
        Additional Communications Provisions (FOR RESIDENTS OF CANADA)
      </SubHeading>. In addition to the consent provided above in the Our
      Communications With You (United States) section, Canadian residents agree
      to the following provisions related to compliance with Canada’s Anti-Spam
      Legislation (“CASL”), Canada’s Personal Information Protection and
      Electronic Documents Act (“PIPEDA”) and Canadian provincial law including
      Alberta’ Personal Information Protection Act (“PIPA”), and Quebec’s Act
      Respecting the Protect of Personal Information in the Private Sector, 1)
      you agree to the provisions governing use and disclosure of personal
      information that are found in our Privacy Policy; 2) because the purpose
      of our communications include your interest in our services, our
      communication with you will continue until you revoke your consent or
      opt-out; and 3) your personal information may also be transmitted to used
      and stored in the United States.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>8. ADVERTISEMENTS AND LINKS TO OTHER SITES.</strong> <br />The
      Services may contain advertisements and hyperlinks to third party websites
      that are not under the control of Provider; we do not endorse,
      investigate, diligence, warrant, guarantee or certify any such sites,
      products, services or providers merely by making them available as a
      convenience to users as potentially of intertest to users. You are
      responsible to review all separate third party terms and use good business
      judgment, diligence and caution when working with a third party or buying
      goods or services from them. When you leave our website, we have no
      control over the content, terms or privacy policy applicable to a third
      party site or platform. We are not your agent. We will not engage with a
      third party on your behalf. Proceed at your own risk; we have no liability
      to you if you are dissatisfied with your third party interaction.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>9. AGENT AND BROKER DIRECTORY.</strong> <br />As a feature of the
      Services, for users’ convenience, we may optionally provide a directory of
      real estate agents and brokers from among our users based on the last
      contact information we have for them in our records. We do not represent
      or warrant that all directory information is accurate or complete, that
      all errors therein will be corrected, or updated in a timely manner. By
      using the Services, a user authorizes us to include their contact and
      profile information (as current in their account with us) in the directory
      unless the user notifies us in writing of their desire to opt out, which
      would be given effect as feasible by us. The directory is not an
      endorsement of a specific agent or broker, their reputation, experience or
      expertise. Anyone seeking to work with a specific broker or agent is
      solely responsible for conducting their own due diligence on the broker or
      agent. We shall not be liable for any use or misuse of the directory.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>10. INTELLECTUAL PROPERTY PROTECTION.</strong> <br />
      <strong>As between you and us</strong>, we and our licensors own our
      websites, intellectual property rights, and content and information
      displayed via the Services, including, without limitation, third-party
      owned or supplied data like MLS data, text, artwork, graphics, logos,
      button icons, images, audio clips, digital downloads, prices, product and
      service descriptions, advertisements, directory information, and data
      compilations (collectively, “Content”). Content is protected by U.S. and
      international trademark, copyright, and other intellectual property laws.
      You do not gain any ownership in Content merely by accessing or using
      Content. You shall not copy, distribute, alter, display, perform, publish,
      or create derivative works from such Content. Systematic retrieval of data
      or other Content from the Services to prepare any collection, compilation,
      database, or directory is strictly prohibited.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Listingbook, Listingbook.com, ELEVATE, RLS2000, AgentJet, eMerge,
      VoicePad, IDX Broker, OutboundEngine, Aiva/AivaChat are among trademarks,
      service marks and tradenames (“Marks”) we own. You do not receive a
      license to use our Marks under this Agreement. You may not use our Marks
      as part of your tradename, trademarks, service marks, logo, or as part of
      a domain name or social media handle. You may not seek a trademark
      registration for our Marks or any marks that are substantially similar. We
      reserve all rights to oppose any such attempt.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      You acknowledge and agree that the MLS, which supplies certain data and
      images used in the Services, owns all copyrights in and to such data and
      images and in the MLS database, and that you will not contest the MLS
      copyright interests therein, nor assist others in doing so. You expressly
      authorize the MLS, which supplies certain data and images used in the
      Services, and its authorized agents and representatives, to access the
      Services , including your user account, for the purpose of verifying
      users’ compliance with the MLS rules and monitoring the display of agents’
      listings on the Services.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      EXCEPT FOR YOUR LIMITED RIGHT TO USE SERVICES AS SET FORTH HEREIN, YOU DO
      NOT GAIN ANY INTEREST, BY IMPLICATION, ESTOPPEL, OR OTHERWISE, OWNERSHIP,
      LICENSE OR RIGHT UNDER OR IN ANY PATENT, TRADEMARK, COPYRIGHT, OR OTHER
      PROPRIETARY RIGHTS OF OURS IN THE SERVICES.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>11. USER SUBMISSIONS.</strong> <br />Content you create yourself,
      as your original creation, that you post, upload, input or submit in
      connection with your use of the Services (your “Submissions”) is owned by
      you, but you hereby grant us a royalty-free, fully paid up, perpetual,
      irrevocable world-wide license to use (including, without limitation, the
      rights to: copy, distribute, transmit, publicly display, publicly perform,
      reproduce, edit, translate, sublicense and reformat your Submissions, and
      to publish your name in connection with your Submissions) your Submissions
      in connection with the operation and promotion of the Services. You may
      not include any improper content in your Submissions that would infringe,
      misappropriate or violate any third party’s intellectual property,
      proprietary, privacy or publicity rights, and will indemnify, defend and
      hold us and our officers, directors, managers, members, employees, agents
      and partners harmless from any third party claims, damages, or judgments,
      including attorneys fees and litigation costs and expenses related to a
      breach of this sentence. Additionally, no Submissions may contain content
      that, in our sole discretion, is illegal, or promotes racism, bigotry,
      hatred, violence, illegal activity or physical harm, death or property
      damage, against any group or individual; harasses or advocate harassment
      of another person; exploits people in a sexual or violent manner; contains
      obscene, pornographic, or offensive subject; is false or misleading,
      defamatory or libelous; or otherwise fails to keep with the good image of
      us and our offerings. We reserve the right, but are not required to
      monitor Submissions for compliance with the terms of this Agreement. You
      rely on Submissions from other users at your own risk and subject to the
      need to do your own due diligence on any information or materials you
      review or use.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>12. DISCLAIMER OF WARRANTIES.</strong> <br /> Provider does not
      represent, guarantee or warrant that the information available on, in or
      through the Services (“Content”) is accurate, complete, timely, or free of
      technical or typographical errors whether provided by Provider or a third
      party. It is your responsibility to verify any information accessible to
      you through the Services. YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF
      SUCH IS AT YOUR SOLE RISK. THE CONTENT IS PROVIDED ON AN “AS IS” AND “AS
      AVAILABLE” BASIS. PROVIDER, ANY MLS, AGENT AND BROKER EXPRESSLY DISCLAIM
      ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
      LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
      PARTICULAR PURPOSE, AND NON- INFRINGEMENT. NONE OF PROVIDER, ANY MLS, OR
      ANY AGENT OR BROKER MAKE ANY WARRANTY THAT THE CONTENT WILL MEET YOUR
      REQUIREMENTS, OR THAT ACCESS TO THE SERVICES AND THE CONTENT WILL BE
      UNINTERRUPTED, TIMELY, SECURE, ACCURATE, VIRUS- FREE OR ERROR FREE; OR
      THAT YOU WILL OBTAIN ANY SPECIFIC RESULTS FROM REVIEWING OR USING CONTENT.
      WE DO NOT ENDORSE, CERTIFY OR INDEPENDENTLY INVESTIGATE ANY AGENT OR
      BROKER; YOU ARE RESPONSIBLE FOR REVIEWING LICENSURE, CREDENTIALS, AND
      EXPERIENCE OF ANYONE YOU CHOOSE TO WORK WITH.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>13. LIMITATION OF LIABILITY.</strong> <br />YOU AGREE THAT NONE OF
      PROVIDER, ANY MLS, AGENT, BROKER OR PARTY INVOLVED IN CREATING, PRODUCING,
      OR DELIVERING THE SERVICES SHALL BE RESPONSIBLE OR LIABLE FOR ANY DIRECT,
      INDIRECT, STATUTORY, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY OR
      SPECIAL DAMAGES WHATSOEVER ARISING OUT OF YOUR ACCESS, USE, MISUSE OR
      INABILITY TO USE THE SERVICES, LOSS OF DATA OR BUSINESS, DAMAGE TO A
      DEVICE USED TO ACCESS THE SERVICES, OR THE CONSEQUENCES OF ANY ACTION YOU
      OR ANY OTHER PERSON TAKE OR FAIL TO TAKE BASED ON CONTENT PROVIDED BY OR
      AS A RESULT OF THE USE OF THE SERVICES.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, THE LIABILITY
      OF PROVIDER AND ITS SUPPLIERS AND LICENSORS TO YOU FOR ANY CAUSE
      WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE
      LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO PROVIDER FOR THE ACCESS TO
      AND USE OF THE SERVICES IN THE 12 MONTHS PRECEDING THE CLAIM. SOME
      JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR
      INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO SOME OF THE ABOVE LIMITATIONS MAY
      NOT APPLY TO YOU.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      You agree that regardless of any statute or law to the contrary, you will
      file any claim or cause of action arising out of or related to your use of
      the Services or this Agreement within one (1) year after such claim or
      cause of action arose or be forever barred.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>14. INDEMNITY.</strong> <br />As a condition to being permitted to
      access the Services, you agree to defend, indemnify and hold harmless
      Provider, and its subsidiaries, affiliates, officers, managers, members,
      employees, agents, and other partners against any and all claims, damages,
      judgments, and expenses, including attorney’s fees and litigation costs
      and expenses, arising from your use of the Services, breach of this
      Agreement, or breach of any third party’s rights. This and any other duty
      of indemnification set forth herein shall survive any termination of your
      account or use of the Services.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>15. TERMINATION OF WEBSITE ACCESS AND ACCOUNT.</strong> <br />{" "}
      Provider in its sole discretion, may terminate your account and any
      corresponding subscriptions, delete any content stored in your account,
      direct you to cease using the Services, and discontinue or restrict your
      access to the Services, all without notice to you and for any reason. If
      your access to the services is through your agent, employer or a
      principal, that party may also suspend or terminate your access to the
      Services and Provider has no control over their doing so. Provider has no
      liability for your in ability to use the Services, in whole or in part,
      for any period of time, or for any modification thereto, or
      discontinuation thereof.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      In addition, provider will periodically from time to time delete old,
      expired, or unused content, data, or articles (images, videos, voice
      assets, websites, or other) in use or in storage from dormant, expired,
      unpaid, or former accounts. Provider may choose to provide reasonable
      notice, if possible, but also reserves the right to delete customer,
      account, profile, or other data without notice.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Provider has the right to monitor, throttle, take down, and/or delete
      content, websites, and data that constitute a potential security risk at
      any time.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>16. PRICING, RENEWALS, AND REFUNDS; NO EARLY TERMINATION.</strong>
      <br />Subscription Terms. Services are offered on an annual subscription
      basis. Your initial subscription will automatically renew on your annual
      renewal date unless you provide us with your written notice to cancel at
      least thirty (30) days prior to your annual renewal date. Send written
      notice of cancellation to <SubHeading>billing@elmstreet.com</SubHeading>.
      Your subscription will renew monthly on your annual renewal date at the
      then current, non-promotional subscription rate. All renewal pricing is
      based upon our then current price schedule, which we may change from time
      to time in our discretion. We reserve the right to raise our rates
      annually without notice to you, even if the increase applies mid-term. No
      early termination is permitted. No fees are refundable except to the
      extent otherwise provided.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Payments. Payments may be paid in a single annual payment at the time of
      sale or by equal monthly installments beginning at the time of sale, as
      offered by Provider. Annual prepayments may be eligible for discounted
      pricing. If, at renewal, Customer wishes to pay monthly, all discounts
      will be lost. Renewals will be billed on the same cadence as the initial
      sale. We invest heavily in the initial set-up, maintenance, and ongoing
      development of Services you purchase and cancellation is limited to
      electing not to renew (rather than terminating early) and subject to
      forfeiture of any prepaid fees.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Upgrades/Downgrades/Addons. Customers are eligible to downgrade and/or
      remove addon’s after a period of six months. Any addon’s elected by
      Customer must be elected for a minimum of six (6) months. Please note that
      changes to subscription could result in the loss of discounts and/or
      change pricing.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      MLS Data. An MLS (Board of Realtors, or Association of Realtors) may
      require vendors like Provider to pay data access fees and/or pass-through
      additional setup or recurring data fees. To cover the cost, we charge
      &quot;MLS Pass-Thru Fees&quot; (eg. Data Management Fee, Data Connection
      Fee, MLS Setup Fee) that gets passed through to customers who use those
      feeds. If our fee to access the MLS increases in the middle of your
      subscription term, we reserve the right to pass on the increase to our
      users notwithstanding anything to the contrary in this Agreement, as a
      condition to the user’s ongoing access to the MLS content.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      Termination for Non-Payment. If Customer defaults in the payment of any
      charges or other amounts due under this Agreement and fails to cure such
      default within ten days after receiving written notice specifying such
      default, then Company may terminate Service without notice.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      For billing inquiries, contact{" "}
      <a href="mailto:billing@elmstreet.com">billing@elmstreet.com</a>.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>17. CREDIT CARD CHARGES.</strong> <br />You authorize Provider’s
      credit card processor (at Provider’s instruction) to process your
      subscription fees and any renewal fees using the credit card made
      available to the payment processor for such purposes. You need to maintain
      a current credit card on file during your subscription term, and update
      any expired, lost or stolen credit card number. For clarity, Provider does
      not collect payment card details, which are provided to the third party
      payment processor for Provider’s benefit and subject to that third party’s
      privacy policy. Failure for a charge to go through may result in
      suspension or termination of your access to the Services without prior
      notice.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>18. AGREEMENT TO ARBITRATE.</strong> <br />
      A. <SubHeading>Arbitration</SubHeading>. You and Provider each agree that
      any and all disputes or claims that relate to or arise from your use of or
      access to the Services, or any products or services sold, offered, or
      purchased through the Services shall be resolved exclusively through final
      and binding arbitration, rather than in court, except that Provider
      reserves the right to seek an injunction and any other available relief in
      a court of competent jurisdiction to protect its intellectual property
      rights. The Federal Arbitration Act governs the interpretation and
      enforcement of this Section 18, which is an agreement to arbitrate. The
      arbitrator, and not any federal, state, or local court or agency, shall
      have exclusive authority to resolve any dispute arising out of or relating
      to the interpretation, applicability, enforceability or formation of this
      Section 18, any part of it, or of this Agreement including, but not
      limited to, any claim that all or any part of this Section 18 is void or
      voidable. The arbitration will be conducted by the American Arbitration
      Association (“AAA”) under its rules and procedures, including the AAA’s
      Supplementary Procedures for Consumer- Related Disputes (as applicable),
      as modified by this Agreement to Arbitrate. The AAA’s rules and a form for
      initiating arbitration proceedings is available on the AAA’s site at
      http://www.adr.org. The arbitration shall be held in the county in which
      you reside or at another mutually agreed location. If the value of the
      relief sought is $10,000 or less, you or Provider may elect to have the
      arbitration conducted by telephone or based solely on written submissions,
      which election shall be binding on you and us subject to the arbitrator’s
      discretion to require an in-person hearing, if the circumstances warrant.
      Attendance at an in- person hearing may be made by telephone or video
      conference by you and/or us, unless the arbitrator requires otherwise. The
      arbitrator will decide the substance of all claims in accordance with the
      laws of the State of North Carolina, USA, including recognized principles
      of equity, and will honor all claims of privilege recognized by law. The
      arbitrator shall not be bound by rulings in prior arbitrations involving
      our other users, but is bound by rulings in prior arbitrations involving
      the same user to the extent required by applicable law. The arbitrator’s
      award shall be final and binding and judgment on the award rendered by the
      arbitrator may be entered in any court having jurisdiction thereof. This
      arbitration provision shall survive termination of this Agreement and the
      closing of your account or your use of or access to our Services, or any
      products or services sold, offered, or purchased through our Services.
      Each party will bear its own costs on connection with the arbitration
      proceeding.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      B. <SubHeading>No Class Action</SubHeading>. You agree that any claims
      against us shall be on an individual only basis (for yourself) and not as
      a plaintiff or class member in any purported class or representative
      action or proceeding. You hereby waive the right to bring any claims
      against us in relation to this Agreement or the Services as part of a
      class action.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      C. <SubHeading>Confidentiality</SubHeading>. The arbitration proceedings
      and arbitration award shall be maintained by the parties as strictly
      confidential, except as is otherwise required by court order or as is
      necessary to confirm, vacate or enforce the award and for disclosure in
      confidence to the parties’ respective attorneys, tax advisors and senior
      management and to family members of a party who is an individual.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      D. <SubHeading>Severability</SubHeading>. With the exception of Section
      18(B) (No Class Action), if an arbitrator or court decides that any part
      of this Section 18 is invalid or unenforceable, the other parts of this
      Section 18 shall still apply. If an arbitrator or court decides that
      Section 18(B) is invalid or unenforceable, then the entirety of this
      Section 18 shall be null and void. In any event, this Agreement shall be
      governed by the laws of the State of North Carolina, USA, without giving
      effect to its conflicts of laws principles even if the rest of Section 18
      were determined null and void.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>19. MISCELLANEOUS.</strong> <br />
      A. <SubHeading>Assignment</SubHeading>. This Agreement shall bind and
      inure to the benefit of Provider’s successors, assigns and licensees.
      Provider shall have the right to assign or otherwise transfer its rights
      or obligations under this Agreement whether by contract or operation of
      law without your consent. You do not have the right to assign, by
      contract, operation of law or otherwise, this Agreement or any of the
      rights, interests, or obligations hereunder.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      B. <SubHeading>Severability</SubHeading>. Subject to Section 18(D) above,
      in the event that any provision of this Agreement is, becomes, or is
      declared by a court of competent jurisdiction to be illegal,
      unenforceable, or void, this Agreement shall continue in full force and
      effect without such provision.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      C. <SubHeading>Waiver</SubHeading>. The failure of Provider at any time or
      times to require performance of any provision hereof shall in no manner
      affect the right of Provider at a later time to enforce the same.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      D. <SubHeading>Applicable Law</SubHeading>. You acknowledge that the
      Content contained in this Services is controlled in and originates from
      the United States. Provider makes no representation that any of the
      Content is appropriate or available for use in other locations. Provider
      has no responsibility for any access to this Services from territories
      where the Content may be illegal or otherwise prohibited. If you choose to
      access this Services from other locations, you do so at your own risk and
      are responsible for compliance with applicable local laws. Any claim
      relating to the use of the Services and any Content shall be governed by
      the internal substantive laws of the State of Texas , without regard to
      its conflicts of laws rules. You expressly consent to the jurisdiction of
      the state and federal courts of North Carolina for any claim that is
      determined not to be subject to the agreement to arbitrate in Section 18,
      including interpretation of the applicability of Section 18.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      E. <SubHeading>Entire Agreement</SubHeading>. This Agreement, together
      with Provider’s order(s), constitutes the entire agreement between you and
      Provider regarding Services and the subject matter of this Agreement. You
      may not supplement, vary or modify any order; all changes to an order must
      be made and approved by Provider. No terms in your acceptance or other
      documentation or correspondence with Provider shall modify the order and
      all such different or supplemental terms outside an order are null and
      void. In the event of a conflict between the terms of this Agreement and
      the order, the terms of this Agreement will prevail, provided the order
      shall be conclusive on pricing, length or subscription term and specific
      Services subscribed. Your use of the Services is subject to Provider’s
      user guidelines for use of the same, as updated from time to time, and
      nothing in this Agreement changes the requirement to abide by the same.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      F. <SubHeading>Amendments</SubHeading>. Provider may amend or modify the
      terms of this Agreement across its user base, unilaterally, and any such
      changes, modifications or amendments to this Agreement shall apply to you
      by the next January 1 of the next calendar year unless the change states
      an earlier effective date. Notification of changes may be made by email to
      you (to your email address of record in your account) or by posting notice
      of the change to the Services. Any use of the Services following the
      effective date of the change shall be deemed to constitute your acceptance
      of such amendments, modifications, or new conditions. This Agreement
      cannot otherwise be amended except by a written amendment signed by
      Provider and by you.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      G. <SubHeading>Notices</SubHeading>. Notices in connection with this
      Agreement to Provider shall be given to Provider by postal mail to: Elm
      Street Technology, LLC, 950 E State Highway 114, Suite 160, Southlake, TX
      76092 USA, or as to a successor address that Provider makes available on
      the Services or through any other reasonable manner. If applicable law
      requires Provider to accept email notices (but not otherwise), then you
      may send Provider email notice to support@elmstreet.com. With respect to
      Provider notices to you, Provider may provide notice by posting in the
      Services or through any other reasonable manner. Instead or in addition,
      Provider may give notice by sending an email to the email address that you
      provide in your account. Notice shall be deemed given upon receipt when
      mailed, 24 hours after it is posted or an email is sent, unless (as to
      email) the sending party is notified that the email address is invalid or
      the message was not delivered.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      H. <SubHeading>Descriptive Headings</SubHeading>. Section headings of this
      Agreement are intended for convenience of reference only and are not
      intended to be a part of or affect the meaning or interpretation of this
      Agreement.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <strong>20. THIRD PARTY SOCIAL MEDIA SERVICES.</strong>
      <br /> You may be able to access third party social media platforms
      through the Services. All use thereof is subject to the third party
      platform’s terms of use, terms of service, community guidelines, privacy
      policy and any other terms it imposes, which we do not control. We have no
      liability to you if your access to the platform is suspended or terminated
      by the third party or if you face consequences for misuse of the platform.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      I HAVE READ THIS AGREEMENT AND AGREE TO ALL OF THE PROVISIONS CONTAINED
      ABOVE.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      © Elm Street LLC. All Rights Reserved Terms&nbsp;
      <a href="/privacy">Privacy</a>
    </Typography>
  </div>
);

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
    maxWidth: "970px",
    margin: "40px auto",
    "& p": {
      maxWidth: "100%",
    },
    "& strong": {
      fontWeight: "bold",
    },
  },
});

export default withStyles(styles)(Elevate);
